import { render, staticRenderFns } from "./HowItWorks.vue?vue&type=template&id=cc84283a&scoped=true&"
import script from "./HowItWorks.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HowItWorks.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./HowItWorks.vue?vue&type=style&index=0&id=cc84283a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc84283a",
  null
  
)

export default component.exports